<template>
  <div class="terms">
    <q-scroll-area :thumb-style="thumbStyle" style="height: 800px" ref="scrollArea">
      <tcs-box v-if="tcsKey" :tcsKey="tcsKey"></tcs-box>
    </q-scroll-area>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import TcsBox from '@components/tcs-box/TcsBox.vue'
export default {
  components: {
    TcsBox,
  },
  data() {
    return {
      tcsKey: '',
      thumbStyle: {
        right: '2px',
        borderRadius: '3px',
        backgroundColor: '#999',
        width: '8px',
        opacity: 1,
      },
    }
  },
  computed: {
    ...mapGetters(['lang']),
  },
  mounted() {
    const lang = this.lang
    if (lang === 'CN') {
      this.tcsKey = 'XYBMIRUIN448N0'
    } else if (lang === 'EN') {
      this.tcsKey = 'XYBM25U3NBBU46'
    } else {
      this.tcsKey = 'XYBMDK6T4S9F7N'
    }
  },
}
</script>
<style lang="scss" scoped>
.terms {
  height: 800px;
  overflow-y: scroll;
  padding: 30px;
  ::v-deep h2 {
    font-size: 20px;
    font-weight: bold;
  }
  ::v-deep h5 {
    margin-bottom: 17px;
    font-size: 20px;
    line-height: 20px;
    font-weight: 500;
    color: #2b2b2b;
  }
  ::v-deep p {
    padding-bottom: 20px;
    margin-bottom: 0;
    font-weight: 400;
    color: #666;
    line-height: 28px;
  }
}
</style>
